import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

const inputCls =
  "w-full rounded-xl border border-white/12 bg-white/5 px-4 py-3 text-white placeholder:text-slate-500 focus:border-arjuna-teal focus:outline-none focus:ring-1 focus:ring-arjuna-teal/40 transition-colors duration-300";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/access-key", { replace: true });
  }, [user, navigate]);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created.");
      navigate("/access-key");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create account"
      subtitle="Start exploring geospatial intelligence for India."
      footer={
        <>
          Already have an account?{" "}
          <Link to="/login" data-testid="link-login" className="text-arjuna-teal hover:underline">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div>
          <label className="overline mb-2 block">Full name</label>
          <input data-testid="register-name" required className={inputCls} value={form.name} onChange={update("name")} placeholder="Aarav Sharma" />
        </div>
        <div>
          <label className="overline mb-2 block">Email</label>
          <input data-testid="register-email" type="email" required className={inputCls} value={form.email} onChange={update("email")} placeholder="you@org.in" />
        </div>
        <div>
          <label className="overline mb-2 block">Password</label>
          <input data-testid="register-password" type="password" required className={inputCls} value={form.password} onChange={update("password")} placeholder="At least 6 characters" />
        </div>
        <button type="submit" disabled={loading} data-testid="register-submit" className="btn-primary w-full">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          {loading ? "Creating…" : "Create account"}
        </button>
      </form>
    </AuthShell>
  );
}
